import { useState, useEffect } from 'react'
import ActionHome from 'material-ui/svg-icons/action/home'
import Fetch from 'utils/fetch'
import HeaderIcon from 'components/header-icon'
import DeleteFamily from 'components/delete-dialog'
import ButtonNewItem from 'components/button-new-item'
import FamilyList from './family-list'
import FamilyForm from './family-form'
import intl from 'react-intl-universal'

import './family.css'
import { formatErrorMessage } from 'utils/handle-error'
import { profileAdminOrMasterData } from 'services/permissions/getPermissions'
import { generateQueryParams } from 'utils/custom-functions'
import { useBudgetFamilyContext } from '../context'
import { familyFilterDefault, validateFilter } from '../utils'
import storePersist from 'utils/store-persist'
import ButtonIcon from 'components/button-icon'
import { IconFilterActive } from 'components/icons/icn-filter-active.icon'
import { IconFilterInactive } from 'components/icons/icn-filter-inactive.icon'
import FamilyFilter from './family-filter'

const Family = () => {
  const { 
    startFetching, 
    stopFetching, 
    handleShowFeedback, 
  } = useBudgetFamilyContext();
  const [families, setFamilies] = useState([])
  const [total, setTotal] = useState(0)
  const [openDelete, setOpenDelete] = useState(false)
  const [currentPage, setCurrentPage] = useState(0)
  const [openForm, setOpenForm] = useState(false)
  const [openEditMode, setOpenEditMode] = useState(false)
  const [idSelected, setIdSelected] = useState(0)
  const [filter, setFilter] = useState(() => 
    storePersist.getValuesJSON('filtersFamily') ?? familyFilterDefault
  );
  const [showFilter, setShowFilter] = useState(false);

  const openFormModal = () => {
    setOpenForm(true)
  }

  const openNewForm = () => {
    setOpenEditMode(false)
    openFormModal()
  }

  const openEditForm = (row) => {
    const selected = families[row]
    setOpenEditMode(true)
    setIdSelected(selected.Id)
    openFormModal()
  }

  const closeForm = () => {
    setOpenForm(false)
  }

  const openDeleteModal = (id) => {
    setOpenDelete(true)
    setIdSelected(id)
  }

  const proccessErro = (exception) => {
    stopFetching()
    handleShowFeedback(formatErrorMessage(exception))
  }

  const refreshSearch = () => {
    closeForm()
    searchFamily(currentPage)
  }

  const searchFamily = (page = 0) => {
    startFetching()

    const _body = {
      FamilyId: filter.FamilyId?.Id,
      MaterialGroupId: filter.MaterialGroupId?.Id,
      _page: page,
      _size: filter._size
    }

    Fetch.get(`/families:paginated?${generateQueryParams(_body)}`)
      .then((response) => proccessData(response.data))
      .then(stopFetching)
      .then(() => setCurrentPage(page))
      .catch((e) => proccessErro(e))
  }

  const proccessData = (data) => {
    setFamilies(data.Data)
    setTotal(data.TotalRecordCount)
  }

  const closeDelete = () => {
    setOpenDelete(false)
  }

  const deleteFamily = () => {
    const idFamily = idSelected

    Fetch.delete(`/families/${idFamily}`)
      .then(closeDelete)
      .then(() => searchFamily(currentPage))
      .then(() => handleShowFeedback(intl.get('master-data.menus.feedback.familySuccessfullyDeleted')))
      .catch((e) => proccessErro(e))
  }

  const handleShowFilter = () => setShowFilter(prev => !prev);

  const handleSearchFilter = (filter) => {
    storePersist.setValuesJSON("filtersFamily", filter);
    setFilter(filter);
    handleShowFilter();
  }

  const handleClearFilter = () => {
    storePersist.setValuesJSON("filtersFamily", familyFilterDefault);
    setFilter(familyFilterDefault);
    handleShowFilter();
  }

  useEffect(() => {
    searchFamily();
  }, [filter]);

  return (
    <div className='family-container'>
      <div className="family-header">
        <HeaderIcon
          title={intl.get('master-data.walletsAndFamilys.familys.header.title')}
          subtitle={intl.get('master-data.walletsAndFamilys.familys.header.subtitle')}
          icon={<ActionHome style={{ width: 45, height: 45 }} color='var(--color-brand-500)' />}
        >
          {profileAdminOrMasterData() &&
            <div title={intl.get('master-data.walletsAndFamilys.familys.actions.newFamily')}>
              <ButtonNewItem
                className="general-button"
                onClick={openNewForm}
              />
            </div>
          }
          <div title={intl.get('master-data.walletsAndFamilys.familys.actions.filter')} className='filterContainer'>
            <ButtonIcon
              onClick={handleShowFilter}
              buttonType='default'
              buttonText={intl.get('filters.filter')}
              buttonIcon={validateFilter(filter) ? <IconFilterActive /> : <IconFilterInactive />}
              className={"button-filter"}
              data-testid="button-family-filter"
            />
          </div>
        </HeaderIcon>
      </div>

      <FamilyList
        data={families}
        countData={total}
        refreshSearch={searchFamily}
        handleEdit={openEditForm}
        handleDelete={openDeleteModal}
        qtRegsPerPage={filter._size}
        profileAdminOrMasterData={profileAdminOrMasterData()}
      />

      {openForm &&
        <FamilyForm
          idEdit={idSelected}
          open={openForm}
          editMode={openEditMode}
          handleClose={closeForm}
          handleRefresh={refreshSearch}
          handleFeedback={handleShowFeedback}
          profileAdminOrMasterData={profileAdminOrMasterData()}
        />
      }

      <DeleteFamily
        open={openDelete}
        title={intl.get('master-data.walletsAndFamilys.familys.deleteFamilyModal.title')}
        handleClose={closeDelete}
        warningMessage={intl.get('master-data.walletsAndFamilys.familys.deleteFamilyModal.description')}
        handleConfirm={deleteFamily}
      />

      <FamilyFilter
        showFilter={showFilter}
        triggerClose={handleShowFilter} 
        handleSearch={handleSearchFilter}
        handleClear={handleClearFilter}
        filtersDefault={filter}
      />
    </div>
  )
}

export default Family
